module.exports = __webpack_public_path__ + "static/media/pic18.07997332.jpg";